import * as React from 'react'

import Svg, {
  ClipPath,
  Defs,
  G,
  Path,
  RadialGradient,
  Stop,
} from 'react-native-svg'

import { IconProps } from '../icons'

const OfferPrecent = ({ size = 24, color = '#000', ...props }: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <G clipPath="url(#a)">
      <Path
        fill="url(#b)"
        d="M17.283 8.058c-.266-.283-.533-.566-.633-.816-.108-.267-.125-.675-.142-1.075-.025-.709-.058-1.517-.608-2.067-.55-.55-1.358-.583-2.067-.608-.4-.017-.808-.034-1.075-.142-.241-.1-.533-.375-.816-.633-.525-.492-1.125-1.059-1.942-1.059s-1.408.559-1.933 1.059c-.284.266-.567.533-.817.633-.267.108-.675.125-1.075.142-.708.025-1.517.058-2.067.608-.55.55-.583 1.358-.608 2.067-.017.4-.033.808-.142 1.075-.1.241-.375.533-.633.816-.492.525-1.058 1.125-1.058 1.942s.558 1.408 1.058 1.942c.267.283.533.566.633.816.109.267.125.675.142 1.075.025.709.058 1.509.608 2.067.55.55 1.359.583 2.067.608.4.017.808.034 1.075.142.242.1.533.375.817.633.525.492 1.125 1.059 1.933 1.059s1.408-.559 1.942-1.059c.283-.266.566-.533.816-.633.267-.108.675-.125 1.075-.142.709-.025 1.517-.058 2.067-.608.55-.55.583-1.358.608-2.067.017-.4.034-.808.142-1.075.1-.241.375-.533.633-.816.492-.525 1.059-1.125 1.059-1.942s-.559-1.408-1.059-1.942ZM7.033 9.167c-.241-.25-.358-.617-.358-1.092 0-.542.125-.967.383-1.283.259-.309.609-.467 1.05-.467.442 0 .775.125 1.017.383.242.259.358.617.358 1.084 0 .558-.125.991-.375 1.291-.25.3-.6.459-1.05.459-.45 0-.783-.125-1.025-.384v.009Zm1.617 3.916c-.142.209-.317.317-.533.317a.635.635 0 0 1-.425-.167.505.505 0 0 1-.184-.4c0-.116.042-.241.125-.358l3.925-5.95c.142-.208.317-.317.534-.317a.6.6 0 0 1 .416.167.528.528 0 0 1 .184.392c0 .125-.042.25-.125.366l-3.917 5.95Zm4.5-.325c-.25.309-.6.459-1.058.459-.459 0-.792-.125-1.034-.384-.241-.258-.366-.625-.366-1.1 0-.541.125-.966.383-1.275.258-.308.608-.466 1.05-.466.442 0 .783.125 1.025.383.242.258.367.625.367 1.092 0 .558-.125.991-.375 1.3l.008-.009Z"
      />
    </G>
    <Defs>
      <RadialGradient
        id="b"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="rotate(132.981 7.94 5.086) scale(20.6527 19.1582)"
        gradientUnits="userSpaceOnUse"
      >
        <Stop stopColor="#9DC2FF" />
        <Stop offset={1} stopColor="#3D7FEB" />
      </RadialGradient>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h20v20H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)
export default OfferPrecent
